import { planEatApi } from "../../../../planEatApi/PlanEatApi";
import { IOfficeContent } from "../../../../planEatApi/PlanEatFacade";
import { VersionsPage } from "../../components/VersionsPage";

export const VersionsForOffice: React.FC = () => (
    <VersionsPage<IOfficeContent>
        section="offices"
        label="Office"
        idParam="officeId"
        getVersions={planEatApi.getVersionsForOffice}
        nameOf={office => office.officeName}
        parentsOf={office => ({ companyId: office.companyId })}
    />
);
